module.exports = __webpack_public_path__ + "static/media/wind.cdea8454.svg";